import loc from 'owa-localize';
import { foldersDiagnosticDataDescription } from './foldersDiagnosticStrings.locstring.json';
import { lazyRegisterDataCollectorIfNotRegistered } from 'owa-diagnostics-data-collection';
import type { FolderHierarchyResult } from 'owa-graph-schema';
export async function registerDataCollector(): Promise<void> {
    const getFoldersDataCollector = {
        dataCollectionAction: getFoldersDataCollectionAction,
        name: 'FolderData',
        odsFileDescription: 'Folders response data',
        description: loc(foldersDiagnosticDataDescription),
    };
    await lazyRegisterDataCollectorIfNotRegistered.importAndExecute(getFoldersDataCollector);
}

const foldersLog = new Map<string, string>();

export function setFoldersDataCollectionInformation(
    mailboxIdentifier: string,
    result: FolderHierarchyResult | Error | string
): void {
    foldersLog.set(mailboxIdentifier, JSON.stringify({ mailboxIdentifier, result }));

    // Register the data collector to upload the folder hierarchy response to logs if user reports an issue
    registerDataCollector();
}

function getFoldersDataCollectionAction(): Promise<string> {
    return Promise.resolve(JSON.stringify(Object.fromEntries(foldersLog)));
}
